import { apiClient, apiClientV2 } from "./configs/axiosConfig";
import ApiResponse from "./interfaces/ApiResponse";
import { MenuResponseV2 } from "./interfaces/MenuResponse";

export enum EnumTypes {
  ADV_CALL_TO_ACTION = "adv_call_to_action",
  ADV_POST_TYPE = "adv_post_type",
  ADV_AMOUNT = "adv_amount",
  ADV_DURATION = "adv_duration",
}
export class MenuApi {
  static getDynamicMenu() {
    return apiClientV2
      .request<MenuResponseV2>({
        url: `social_hub/menu`,
        method: "POST",
        data: {},
      })
      .then((response) => {
        return response.data;
      });
  }

  static getEnum(email: string, token: string, type: string) {
    return apiClientV2
      .request<any>({
        url: `social_hub/enum`,
        method: "POST",
        data: { enum_type: type },
      })
      .then((response: ApiResponse<any>) => {
        return response.data;
      });
  }
}
